module.exports = __webpack_public_path__ + "img/2.c0276b95.jpg";